<div class="lds-ripple-holder">
    <div class="lds-ripple"><div></div><div></div></div>
</div>